<div style="display: table; margin: 0 auto;">
  <img src="assets/loading.gif" />
</div>
